import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import type { LC_GetTimezonesOut, Timezone } from './timezones.types';
import { mapTimezoneOutToModel } from './timezones.mapper';


export class TimezoneCatalogService {
  /** GET /v1/catalog/timezones */
  async getTimezones(signal?: AbortSignal): Promise<ApiResponse<Timezone[]>> {
    const response = await apiClient.get<LC_GetTimezonesOut>(
      API_CONFIG.ENDPOINTS.CATALOG.TIMEZONES,
      { signal },
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: response.data.map(mapTimezoneOutToModel),
      };
    }

    return { ...response, data: null };
  }
}

export const timezoneCatalogService = new TimezoneCatalogService();
